import { useDocument } from "../../../../firebase-files/hooks/useDocument";
import "./PlantationTwoFooter.scss";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

// ✅ Function to format numbers → dash after 7 digits
const formatPhone = (num) => {
  if (!num) return "";
  const onlyNums = num.replace(/\D/g, ""); // remove non-digits
  if (onlyNums.length <= 7) return onlyNums;
  return onlyNums.slice(0, 7) + "-" + onlyNums.slice(7);
};

const PlantationTwoFooter = () => {
  const navigate = useNavigate();
  const { document: organisationDoc } = useDocument("settings", "organisation");
  const { document: socialDoc } = useDocument("settings", "socialmedia");

  const whatsapp = socialDoc?.socialmedia?.whatsapp;
  const instagram = socialDoc?.socialmedia?.instagram;
  const facebook = socialDoc?.socialmedia?.facebook;

  // Get the current year
  const currentYear = new Date().getFullYear();

  return (
    <footer className="PlantationTwoFooter">
      <div className="footer-content">
        {/* Quick Links */}
        <div className="footer-section">
          <h4>QUICK LINKS</h4>
          <ul>
            <li className="clickable-item" onClick={() => navigate("/")}>
              Home
            </li>
            <li className="clickable-item" onClick={() => navigate("/faq")}>
              FAQ
            </li>
            <li
              className="clickable-item"
              onClick={() => navigate("/notifications")}
            >
              Notifications
            </li>
            <li
              className="clickable-item"
              onClick={() => navigate("/products-two")}
            >
              Products & Services
            </li>
          </ul>
        </div>

        {/* Useful Links */}
        <div className="footer-section">
          <h4>USEFUL LINKS</h4>
          <ul>
            <li className="clickable-item" onClick={() => navigate("/aboutus")}>
              About Us
            </li>
            <li
              className="clickable-item"
              onClick={() => navigate("/term-condition")}
            >
              Disclaimer
            </li>
            <li className="clickable-item" onClick={() => navigate("/contact")}>
              Contact Us
            </li>
            <li
              className="clickable-item"
              onClick={() => navigate("/returnpolicy")}
            >
              Return Policy
            </li>
            <li
              className="clickable-item"
              onClick={() => navigate("/privacy-policy")}
            >
              Privacy Policy
            </li>
            <li
              className="clickable-item"
              onClick={() => navigate("/term-condition")}
            >
              Terms & Conditions
            </li>
          </ul>
        </div>

        {/* Get in Touch */}
        <div className="footer-section">
          <h4>GET IN TOUCH</h4>
          <ul>
            {/* WhatsApp */}
            {whatsapp && (
              <li className="footer-contact-item">
                <FontAwesomeIcon icon={faWhatsapp} className="icon whatsapp" />
                <a
                  href={`https://wa.me/${whatsapp.replace(/\D/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {formatPhone(whatsapp)}
                </a>
              </li>
            )}

            {/* Phone Numbers */}
            {organisationDoc && Array.isArray(organisationDoc.contact_number) ? (
              organisationDoc.contact_number.map((number, index) => (
                <li key={index} className="footer-contact-item">
                  📞{" "}
                  <a href={`tel:${number}`}>
                    {formatPhone(number)}
                  </a>
                </li>
              ))
            ) : (
              organisationDoc?.contact_number && (
                <li className="footer-contact-item">
                  📞{" "}
                  <a href={`tel:${organisationDoc.contact_number}`}>
                    {formatPhone(organisationDoc.contact_number)}
                  </a>
                </li>
              )
            )}

            {/* Emails */}
            {organisationDoc && Array.isArray(organisationDoc.email) ? (
              organisationDoc.email.map((email, index) => (
                <li key={index} className="footer-contact-item">
                  📧 <a href={`mailto:${email}`}>{email}</a>
                </li>
              ))
            ) : (
              organisationDoc?.email && (
                <li className="footer-contact-item">
                  📧 <a href={`mailto:${organisationDoc.email}`}>
                    {organisationDoc.email}
                  </a>
                </li>
              )
            )}

            {/* Instagram */}
            {instagram && (
              <li className="footer-contact-item">
                <FaInstagram className="icon instagram" />
                <a
                  href={instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {instagram}
                </a>
              </li>
            )}

            {/* Facebook */}
            {facebook && (
              <li className="footer-contact-item">
                <FaFacebookF className="icon facebook" />
                <a
                  href={facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {facebook}
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="text-color text-center p-4 footer-bottom">
        &copy; {currentYear} {organisationDoc && organisationDoc.full_name}. All
        rights reserved
        <br />
        <a href="https://www.hyperclouddigital.com/" target="_blank">
          {organisationDoc && organisationDoc.copyRightArea ? (
            organisationDoc.copyRightArea.trim() !== "" ? (
              <>{organisationDoc.copyRightArea}</>
            ) : (
              <>
                Design & Developed by
                <br />
                Hyper Cloud Digital Solutions
              </>
            )
          ) : (
            <>
              Design & Developed by
              <br />
              Hyper Cloud Digital Solutions
            </>
          )}
        </a>
      </div>
    </footer>
  );
};

export default PlantationTwoFooter;
